import styled from "styled-components";
import {fontFamilies} from "../../theme/tokens";

/**
 * The subtle "From contacts" affordance under the recipient chips (ui#166) — a borderless ghost
 * button in the house accent, matching the create card's flat, token-driven language (no boxes).
 */
export const FromContactsButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	margin-top: 9px;
	min-height: 40px;
	padding-inline: 4px;
	border: none;
	background: none;
	cursor: pointer;
	font: 600 12.5px ${fontFamilies.sans};
	color: ${({theme}) => theme.tokens.linkInk};
	border-radius: 7px;
	transition: color 0.14s;

	&:hover {
		color: ${({theme}) => theme.tokens.linkHover};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}

	@media (max-width: 480px) {
		min-height: 44px;
	}
`;
